export default (state, action) => {
	if (state == null || state.data == null) return null;
	const targetDocumentId = action?.documentId;
	const targetParentId = action?.parentId;
	const mapRelatedDocuments = (document) => {
		if (targetDocumentId === document?.id) {
			return {
				...document,
				...action.payload
			};
		} else return {...document};
	};

	const mapTechnology = (technology) => {
		if (targetParentId === technology?.id) {
			return {
				...technology,
				relatedDocuments: technology?.relatedDocuments?.map(mapRelatedDocuments)
			};
		} else {
			return {
				...technology
			};
		}
	};

	const newState = {
		...state,
		data: state?.data?.map(mapTechnology)
	};

	return newState;
};
